import Button from "@components/Button";
import CircularLoader from "@components/CircularLoader";
import { LoadingBar } from "@components/LoadingScreens/LoadingBar";
import ScalableWrapper from "@components/ScalableWrapper";
import View from "@components/View";
import { useManager } from "@src/contexts/WarsContext";
import { images } from "@utils/media";
import { useState } from "react";

const ClaimServerRewardPopup = ({ closePopup }: { closePopup: () => void }) => {
  const manager = useManager();
  const [claimed, setClaimed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const claimReward = async () => {
    setIsLoading(true);
    const data =
      await manager.claimServerReward();
    if (data) {
      setIsLoading(false);
      setClaimed(true);
    }
  };

  return (
    <View className="w-screen h-dvh absolute top-0 left-0 z-[999999] font-[Slackey]">
      <View
        enableEventCapturing
        className="w-full h-full absolute top-0 left-0 bg-black/60"
      />

      <ScalableWrapper maintainAspectRatioBy="height">
        {claimed ? (
          <View className="w-full h-full flex items-center justify-center">
            <View
              enableEventCapturing
              className="relative bg-[#F72EC5] w-[40rem] p-1.5 rounded-xl flex flex-col items-center"
            >
              <Button
                className="bg-transparent border-none outline-none absolute -top-4 -right-4"
                onClick={closePopup}
              >
                <img
                  src={images.ClosePopupIcon}
                  alt="close-popup"
                  className="w-8 h-8 object-contain"
                />
              </Button>
              <h1
                className="text-white mt-0.5 mb-2"
                style={{ textShadow: "0px 3.1px 0px rgba(0, 0, 0, 1)" }}
              >
                Reward claimed!
              </h1>
              <View className="w-full h-80 bg-gradient-to-t from-[#3355FF] to-[#5B7CFF] rounded-b-xl overflow-hidden">
                <View
                  className="w-full h-full bg-cover bg-no-repeat flex flex-col items-center justify-center gap-4"
                  style={{ backgroundImage: `url(${images.TilesBackground})` }}
                >
                  <View
                    className="w-full h-52 flex flex-col items-center justify-center text-center text-white leading-none px-12"
                    style={{ textShadow: "0px 3.1px 0px rgba(0, 0, 0, 1)" }}
                  >
                    <h1>Now you can use your reward!</h1>
                  </View>
                  <View className="flex justify-center">
                    <View
                      enableEventCapturing
                      style={{ backgroundImage: `url(${images.PopupButton})` }}
                      className="w-96 h-14 bg-contain bg-no-repeat"
                    >
                      <Button
                        onClick={() => {
                          closePopup();
                        }}
                        className="flex items-center justify-center bg-transparent border-none outline-none w-96 h-14 font-[Slackey] text-2xl"
                      >
                        <span>Close!</span>
                      </Button>
                    </View>
                  </View>
                </View>
              </View>
            </View>
          </View>
        ) : (
          <View className="w-full h-full flex items-center justify-center">
            <View
              enableEventCapturing
              className="relative bg-[#F72EC5] w-[40rem] p-1.5 rounded-xl flex flex-col items-center"
            >
              <Button
                className="bg-transparent border-none outline-none absolute -top-4 -right-4"
                onClick={closePopup}
              >
                <img
                  src={images.ClosePopupIcon}
                  alt="close-popup"
                  className="w-8 h-8 object-contain"
                />
              </Button>
              <h1
                className="text-white mt-0.5 mb-2"
                style={{ textShadow: "0px 3.1px 0px rgba(0, 0, 0, 1)" }}
              >
                Server has been joined!
              </h1>
              <View className="w-full h-80 bg-gradient-to-t from-[#3355FF] to-[#5B7CFF] rounded-b-xl overflow-hidden">
                <View
                  className="w-full h-full bg-cover bg-no-repeat flex flex-col items-center justify-center gap-4"
                  style={{ backgroundImage: `url(${images.TilesBackground})` }}
                >
                  <View
                    className="w-full h-52 flex flex-col items-center justify-center text-center text-white leading-none px-12"
                    style={{ textShadow: "0px 3.1px 0px rgba(0, 0, 0, 1)" }}
                  >
                    <h1>Now you can claim your reward!</h1>
                  </View>
                  <View className="flex justify-center">
                    <View
                      enableEventCapturing
                      style={{ backgroundImage: `url(${images.PopupButton})` }}
                      className="w-96 h-14 bg-contain bg-no-repeat"
                    >
                      <Button
                        onClick={claimReward}
                        className="flex items-center justify-center bg-transparent border-none outline-none w-96 h-14 font-[Slackey] text-2xl"
                      >
                        <div className="flex items-center justify-center w-1/2 gap-2">
                          {isLoading ? (
                            <>
                              {" "}
                              <CircularLoader className="w-5" /> Claiming...{" "}
                            </>
                          ) : (
                            <span>Claim Now!</span>
                          )}
                        </div>
                      </Button>
                    </View>
                  </View>
                </View>
              </View>
            </View>
          </View>
        )}
      </ScalableWrapper>
    </View>
  );
};

export default ClaimServerRewardPopup;
